export default [
  {
    path: '/administracao/ultimas-visualizacoes',
    component: () =>
      import('@/pages/Administracao/UltimasVisualizacoes/Index.vue'),
  },
]
